import React from 'react';
import { generateImageSource } from '../../utils/generateImageSource';
import SplashPageButton from './SplashPageButton';
import { EXP_ROUTES } from '../../utils/constants';

const PostJobsCard = () => {

  return (
    <div className="ptp-splash-page__post-jobs-card">
      <div className="ptp-splash-page__post-jobs-image-container ptp-hidden__xs-down">
        <img
          src={generateImageSource('/images/v1/path-to-pro/splash-page-post-jobs.jpg')}
          className="ptp-splash-page__post-jobs-image"
          alt="post-jobs"
        />
      </div>
      <div className="ptp-splash-page__text-container">
        <div>
          <div className="ptp-splash-page__card-title">
            Post Jobs
          </div>
          <div>
            Looking to Hire? Path to Pro is here to help! Easily share your job openings
            with our growing network of job seekers. Just click “Post Jobs” to list your open jobs,
            for free!
          </div>
        </div>
        <div className="ptp-splash-page__post-jobs-buttons">
          <SplashPageButton
            buttonText="Post a Job"
            destination={EXP_ROUTES.CREATE_JOB_POSTING}
            analyticsLabel="post a job"
            variant="primary"
            fullWidth
          />
          <div className="ptp-splash-page__btn-space" />
          <SplashPageButton
            buttonText="Manage Job Postings"
            destination={EXP_ROUTES.JOB_POSTINGS}
            analyticsLabel="get started"
            variant="secondary"
            fullWidth
          />
        </div>
      </div>
    </div>
  );
};

export default PostJobsCard;
